const ACTIVE_SUBJECT_KEY = "teacherActiveSubjectId";

export const getTeacherSubjects = (user) => {
    if (!user) return [];
    let list = [];
    if (Array.isArray(user.teachSubjects) && user.teachSubjects.length > 0) {
        list = [...user.teachSubjects];
    } else if (user.teachSubject && (user.teachSubject._id || user.teachSubject.id)) {
        list = [user.teachSubject];
    }
    const byId = new Map();
    for (const row of list) {
        const id = getSubjectId(row);
        if (id && !byId.has(String(id))) byId.set(String(id), row);
    }
    return [...byId.values()];
};

export const getSubjectId = (subject) => subject?._id || subject?.id || null;

export const getClassFromSubject = (subject) => {
    if (!subject) return null;
    const sclass = subject.sclassName;
    if (sclass && typeof sclass === "object") {
        return {
            _id: sclass._id || sclass.id,
            sclassName: sclass.sclassName,
        };
    }
    if (subject.classId) {
        return { _id: subject.classId, sclassName: typeof sclass === "string" ? sclass : "—" };
    }
    return null;
};

export const readActiveSubjectId = (teacherId) => {
    if (!teacherId) return null;
    try {
        return localStorage.getItem(`${ACTIVE_SUBJECT_KEY}:${teacherId}`);
    } catch {
        return null;
    }
};

export const writeActiveSubjectId = (teacherId, subjectId) => {
    if (!teacherId || !subjectId) return;
    try {
        localStorage.setItem(`${ACTIVE_SUBJECT_KEY}:${teacherId}`, String(subjectId));
    } catch {
        /* ignore */
    }
};

export const resolveActiveSubject = (user, preferredId) => {
    const subjects = getTeacherSubjects(user);
    if (subjects.length === 0) return null;
    const teacherId = user?._id || user?.id;
    const stored = preferredId || readActiveSubjectId(teacherId);
    if (stored) {
        const match = subjects.find((s) => String(getSubjectId(s)) === String(stored));
        if (match) return match;
    }
    return subjects[0];
};
